import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './pages/home/home.jsx';
import ChatBox from './components/chatbox/ChatBox';

export default function AppRouter(props) {
  return (
    <BrowserRouter>
      <ChatBox />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}